module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-stub-mid-1.d98db50c.svg";